import { useState, useMemo, useCallback } from 'react';
import { SORT_TYPES } from '../constant';

export default function useFilterBar(members = []) {
  const [search, setSearch] = useState('');
  const [role, setRole] = useState('');
  const [sort, setSort] = useState(SORT_TYPES.JOIN_DESC);

  const handleSearchChange = useCallback((value) => {
    setSearch(value);
  }, []);

  const handleRoleChange = useCallback((value) => {
    setRole(value);
  }, []);

  const handleSortChange = useCallback((value) => {
    setSort(value);
  }, []);

  const filteredMembers = useMemo(() => {
    if (!Array.isArray(members)) return [];

    let result = [...members];

    const keyword = search?.trim()?.toLowerCase();
    if (keyword) {
      result = result.filter((item) => {
        const name = (item?.name || item?.uName || '').toLowerCase();
        const email = (item?.email || '').toLowerCase();
        return name.includes(keyword) || email.includes(keyword);
      });
    }

    if (role) {
      result = result.filter(
        (item) => item?.role?.toUpperCase() === role.toUpperCase()
      );
    }

    result.sort((a, b) => {
      switch (sort) {
        case SORT_TYPES.JOIN_ASC:
          return (Number(a?.createdAt) || 0) - (Number(b?.createdAt) || 0);
        case SORT_TYPES.NAME_ASC: {
          const nameA = a?.name || a?.uName || '';
          const nameB = b?.name || b?.uName || '';
          return nameA.localeCompare(nameB);
        }
        case SORT_TYPES.PURCHASE_DESC:
          return (Number(b?.orderCount) || 0) - (Number(a?.orderCount) || 0);
        case SORT_TYPES.JOIN_DESC:
        default:
          return (Number(b?.createdAt) || 0) - (Number(a?.createdAt) || 0);
      }
    });

    return result.map((item, index) => ({
      ...item,
      no: index + 1,
    }));
  }, [members, search, role, sort]);

  return {
    search,
    role,
    sort,
    handleSearchChange,
    handleRoleChange,
    handleSortChange,
    filteredMembers,
  };
}
